import UserError from 'branch-node-core/branch/errors/UserError';
import dash_api from '../support/dash_api';
import imageUpload from '../support/imageUpload';
import { validateAndUpdateFeedbackPayload } from '../support/feedbackUtils';
import NotificationActions from './NotificationActions';
import { ReduxAsyncAction } from '../support/utils';

const SaveFeedback = new ReduxAsyncAction('SAVE_FEEDBACK');
SaveFeedback.registerRequest(payload => {
  validateAndUpdateFeedbackPayload(payload);
  if (!payload.file) {
    return dash_api
      .post('/v1/feedback', payload)
      .then(res => {
        NotificationActions.showNotification(
          'Thank you for your feedback!',
          'success'
        );
        return { feedback: res.data };
      })
      .catch(err => {
        NotificationActions.showNotification(
          'Oh no! Something went wrong. Please try again, we value your feedback.',
          'error'
        );
      });
  } else {
    const directory = 'feedback';
    return imageUpload('/v1/image', { directory }, { icon: payload.file })
      .then(res => {
        const newPayload = { ...payload };
        newPayload.fileUrl = res;
        return dash_api.post('/v1/feedback', newPayload).then(res => {
          NotificationActions.showNotification(
            'Thank you for your feedback!',
            'success'
          );
          return { feedback: res.data };
        });
      })
      .catch(err => {
        if (err instanceof UserError) {
          NotificationActions.showNotification(err.message, 'error');
        } else {
          NotificationActions.showNotification(
            'Oh no! Something went wrong. Please try again, we value your feedback.',
            'error'
          );
        }
      });
  }
});

export const SAVE_FEEDBACK = SaveFeedback.constants;
export const saveFeedback = SaveFeedback.request;
